// `parseFloat("8,5")` returns `8` because parseFloat stops at the first
// non-decimal-point character. On de-DE / fr-FR / it-IT locales the
// decimal separator is a comma, so user input from the system keyboard
// (RPE, plate-calc target, etc.) silently truncates: "8,5" → 8 →
// passes the 1..10 RPE range check as 8, the half-step is gone with no
// indication to the lifter.
//
// Normalising comma → dot before parseFloat covers every locale we
// ship (EN/IT/FR/DE/RU per memory). Intl.NumberFormat parsing would be
// stricter but RN's Intl is uneven across Hermes versions and we only
// need the comma case in practice. Trimming first lets us tolerate
// trailing whitespace from autofill / paste.
export function parseLocaleNumber(s: string): number {
  if (typeof s !== 'string') return NaN;
  return parseFloat(s.trim().replace(',', '.'));
}
